import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="What role does your sales team now play in the value chain?" />

                     
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/&amp;title=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;summary=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-ideas-cogs.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>What role does your sales team now play in the value chain?</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>16 September 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Is your sales department a Wholesaler or Retailer?</h3>

<div className="rich-text"><p>It has often crossed my mind that commissioned sales people are actually acting as 'retailers'. Allow me to explain this somewhat odd sounding concept.</p><p>I’m just finishing my second book (The Future of the Sales Profession) which will be due for release in early March time-frame, and during the research phase I conducted some good old <em>value chain analysis</em> in order to map the changing nature of the sales role.</p><h3><b>The Value Chain:</b></h3><p>It's clear (to me at least) that under the now extinct vendor-push model, the sales person was in effect the ‘retailer or re-seller’ in the value chain. Vendors have always employed sales people as ‘autonomous agents’ to own a territory, and to collect a commission (clipping each ticket) on every sale that they make. Of course, this model has always added significantly to the vendors Cost of Customer Acquisition (CoCA).</p></div>
<img alt="The Value Chain" className="img-responsive" height="251" src="../../../media/images/AAEAAQAAAAAAAAdDAAAAJDE4YWVkZmMxLTliMGQtNDYyMS.width-647.png" width="647"/>

<div className="rich-text"><h3><b>Information Parity has changed the entire value chain:</b></h3><p>Today's customer-pull models are now producing subtle (and some not-so-subtle) changes to the dynamics of the traditional value chain, creating what is effectively a ‘pincer movement', whereby the sales person is being squeezed from both sides of the value chain. That is, poor old “piggy in the middle” is now being seen <strong>(in some cases)</strong> as an unnecessary overhead or <em>value destroyer</em>:</p><p>a)      Buyers will always seek to go direct to the manufacture for a better deal, and today's buyers are telling us that they do NOT value the sales person unless the sales person offers unique and valuable commercial insights (specialist knowledge).</p><p>b)      Vendor leaders (sales person’s employer), on the other hand, are now more frequently assessing the extent to which their generalist 'order takers' (majority of today's B2B sales people) are now simply an intermediary that adds no value and instead contributes to supply chain ‘leakage’ and unnecessary cost overhead.</p><p>Please don’t shoot the messenger here, I’m simply outlining the undeniable dynamics of evolving value chains across many industries.</p><h3><b>From Vendor-Push to Customer-Pull:</b></h3><p>Now that information asymmetry no longer exists, the scales have been tipped back to the buyers. As we all know, customer-pull models mean that buyers are in control and the role of the sales person now changes from pushy, revenue focused, commissioned agent, to in-house, customer success facilitator and educator.</p></div>
<img alt="Customer Pull Model" className="img-responsive" height="267" src="../../../media/images/AAEAAQAAAAAAAAfyAAAAJDQxMGQ3N2IzLTVjMTEtNGE1NS.width-647.png" width="647"/>

<div className="rich-text"><p>Thus, please consider the following:</p><p>1.      Buyers ARE increasingly bypassing the sales person, effectively disintermediating the value chain via self-service and eCommerce options which enables a ‘direct’ engagement with the vendor/manufacturer.</p><p>2.      Due to the trends outlined in point 1 (above), vendors MUST now offer buyers better value, and the high levels of <em>customer experience</em> that they demand. Flexible consumption based models and risk share, combined with a full arms-around partnership based approach to adding long term value to the buyer.</p><p>If you are following me to this point, then please ponder these subsequent questions:</p><p></p><ul><li>What happens when buyers do NOT see value in their generalist sales person? <strong>Answer</strong> – they go into Sales Person Avoidance Mode.<br/></li><li>What happens when vendors don’t see their sales people as adding value to the customer acquisition process? <strong>Answer</strong> – they downsize or re-allocate their sales resources.<br/></li></ul><p></p><p>Sales people acting as a 'channel' to market was fine when the power imbalance was with the vendors in strong demand-driven growth markets. However, the new reality is that we now have a swing to the demand side. Total supply chain performance must now be improved because buyers demand it, and vendors must therefore become more cost effective.</p><p>So what does all of this <em>gobbledygook</em> really mean for us sales folks?</p><p>Sounds so obvious, but if you are in sales and you are not creating value that is AT LEAST commensurate with your total cost to your employer then you are at risk. Should I repeat that for effect?</p><p>Like it or not, more and more outside (field) sales people will be forced to become inside-only sales people as part of a combined 'customer-success team'. Buyers don’t need to be face-to-face anymore, and vendors can reduce massive amounts of wasted (non-selling) time by creating <em>inside </em>capabilities. Field (or outside) sales was fine with buyers resided in the field, but buyers now reside online. Hence the rise and rise of inside capabilities and <em>Martech </em>platforms.</p><p>I believe that one likely outcome of all of this will be that ALL vendors will gradually transitions towards inside sales teams, with maybe one of two specialist 'outside' sales people (or SME's) that are available to physically meet with customers should they need it. Another outcome here is that sales people will move <em>upstream </em>and eventually have to get used to the idea that being paid a commission (like a retailer or reseller) for helping to educate a customer is becoming a thing of the past. With both sides of the value chain squeezing the intermediary, I going to agree with <a href="http://bit.ly/2jm9mph">Derek Wyszynski </a>that commissions will eventually disappear from vendor businesses. Think about it – do other in-house teams earn commission? Do marketing people earn a commission? Do customer service or customer success people earn a commission? Do customers like knowing that their ‘trusted adviser’ has a self-interest due to his/her comp plan? More importantly, will sales people stop producing if they are not being paid a commission? Not when the alternative is no job at all.</p><p>More and more companies (such as Amazon Web Services) are now waking up to this new reality and instead of paying commissions, which often drives the wrong behaviors, these savvy vendors are moving to models that reward customer facing teams with <em>equity </em>(shares) upon reaching customer success outcomes. Sounds sensible to me on every level. So, watch this space sales people, and dare I say it: <em>‘make hay while the sun shines’.</em></p><p>I would love to hear from you about your industry value chain?….are you seeing some changing dynamics in your value chain? Please let me know if you agree or disagree with this concept?</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/&amp;title=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;summary=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=What%20role%20does%20your%20sales%20team%20now%20play%20in%20the%20value%20chain%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/what-role-does-your-sales-team-now-play-value-chain/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>


      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 